import { useEffect, useLayoutEffect } from 'react';
import config from '../../config';
import injectChatway from '../../utils/chatway/injectChatway';
import {
  installChatwayTravelerSync,
  setChatwayTravelerPayloadSource,
  syncChatwayTravelerFromApp,
  visitorPayloadFromTripsAuth,
} from '../../utils/chatway/chatwayTravelerSync';
import { useAuthStore } from '../../store';

/** z3 order: install sync + hooks, then load widget script. */
const ChatwayBootstrap = () => {
  const { loggedInTraveler, sessionId, personType } = useAuthStore();

  useLayoutEffect(() => {
    installChatwayTravelerSync();
    injectChatway(config.CHATWAY_WIDGET_ID);
  }, []);

  useEffect(() => {
    setChatwayTravelerPayloadSource(() => visitorPayloadFromTripsAuth({
      loggedInTraveler,
      sessionId,
      personType,
    }));
    syncChatwayTravelerFromApp();
  }, [loggedInTraveler, sessionId, personType]);

  return null;
};

export default ChatwayBootstrap;
